var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.svgLogo)?_c('div',{staticClass:"third-party-logo"},[_c(_vm.svgLogo,{tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }